export type InterestCategory = {
  name: string;
  interests: string[];
};

export const INTEREST_CATEGORIES: InterestCategory[] = [
  { name: 'Travel', interests: ['Backpacking', 'Road Trips', 'Solo Travel', 'Luxury Travel', 'Digital Nomad', 'Adventure Travel', 'City Exploration', 'Beach Trips', 'Mountains', 'Camping'] },
  { name: 'Food & Drinks', interests: ['Street Food', 'Fine Dining', 'Cafes', 'Bars', 'Cocktails', 'Wine Tasting', 'Beer', 'Cooking', 'Vegan Food', 'Desserts'] },
  { name: 'Nightlife', interests: ['Clubbing', 'House Music', 'Techno', 'Hip Hop', 'Live DJs', 'Pub Crawls', 'After Parties', 'Festivals', 'Dance', 'Karaoke'] },
  { name: 'Sports & Fitness', interests: ['Gym', 'Running', 'Football', 'Basketball', 'Yoga', 'Hiking', 'Cycling', 'Swimming', 'Martial Arts', 'CrossFit'] },
  { name: 'Music', interests: ['Rap', 'Pop', 'Rock', 'EDM', 'Jazz', 'Classical', 'Indie', 'Lo-fi', 'Live Concerts', 'Singing'] },
  { name: 'Art & Creativity', interests: ['Photography', 'Painting', 'Graphic Design', 'Illustration', '3D Art', 'Videography', 'Content Creation', 'Fashion', 'Tattoo Art', 'Animation'] },
  { name: 'Social & Culture', interests: ['Meeting People', 'Languages', 'Cultural Exchange', 'Volunteering', 'Networking', 'Events', 'Public Speaking', 'Debates', 'History', 'Museums'] },
  { name: 'Tech & Gaming', interests: ['Gaming', 'PC Gaming', 'Console Gaming', 'AI', 'Startups', 'Coding', 'Cybersecurity', 'Web3', 'Gadgets', 'Esports'] },
  { name: 'Outdoors', interests: ['Nature', 'Sunsets', 'Photography Walks', 'Picnics', 'Fishing', 'Climbing', 'Kayaking', 'Skiing', 'Snowboarding', 'Wildlife'] },
  { name: 'Relax & Lifestyle', interests: ['Netflix', 'Reading', 'Meditation', 'Spa', 'Journaling', 'Podcasts', 'Shopping', 'Minimalism', 'Self Growth', 'Coffee'] },
];

export const BUILT_IN_INTEREST_KEYS = new Set(
  INTEREST_CATEGORIES.flatMap(category => category.interests).map(interest => interest.toLowerCase()),
);

const toInterestKey = (value: string) => value
  .toLowerCase()
  .replace(/&/g, ' and ')
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_|_$/g, '');

export const getInterestCategoryTranslationKey = (category: string) =>
  `interests.categories.${toInterestKey(category)}`;

export const getInterestTranslationKey = (interest: string) =>
  `interests.items.${toInterestKey(interest)}`;
